import { DateRangePreset } from "@commonsku/styles";
import { DateRangePresetPivots } from "../../filters/components/DateRangePicker";

export enum MetricFilter {
    Total = "TOTAL",
    Booked = "BOOKED",
    Billed = "BILLED",
}

export const METRIC_PRESETS = [
    {
        label: "Total",
        value: MetricFilter.Total,
    },
    {
        label: "Booked Margin",
        value: MetricFilter.Booked,
    },
    {
        label: "Billed Margin",
        value: MetricFilter.Billed,
    },
];

export const BASE_DATE_RANGE_PRESETS: DateRangePreset[] = [
  {
    name: "this_month",
    label: "This Month",
  },
  {
    name: "this_quarter",
    label: "This Quarter",
  },
  {
    name: "this_year",
    label: "This Year",
  },
];

export const PIVOT_DATE_RANGE_PRESETS: DateRangePresetPivots = {
  this_month: [
    {
      name: "last_month",
      label: "Last month (full)",
    },
    {
      name: "last_month_to_date",
      label: "Last month (to date)",
    },
    {
      name: "this_month_last_year",
      label: "This month last year (full)",
    },
    {
      name: "this_month_last_year_to_date",
      label: "This month last year (to date)",
    },
  ],
  this_quarter: [
    {
      name: "previous_quarter",
      label: "Last quarter (full)",
    },
    {
      name: "previous_quarter_to_date",
      label: "Last quarter (to date)",
    },
    {
      name: "this_quarter_last_year",
      label: "This quarter last year (full)",
    },
    {
      name: "this_quarter_last_year_to_date",
      label: "This quarter last year (to date)",
    },
  ],
  this_year: [
    {
      name: "last_year",
      label: "Last year (full)",
    },
    {
      name: "last_ytd",
      label: "Last year (to date)",
    },
  ],
};